function parseToFloat(value) {
  const parsed = parseFloat(value)
  return Number.isFinite(parsed) ? parsed : undefined
}

export function prepareTrackingItem(attributes, options = {}) {
  const {
    id,
    title,
    affiliation,
    index,
    itemBrand,
    itemCategory,
    subcategory,
    itemCategory3,
    itemCategory4,
    itemCategory5,
    itemListId,
    itemListName,
    itemVariant,
    locationId,
  } = attributes

  const { price, discount } = options

  return {
    item_id: String(id),
    item_name: title,
    affiliation: affiliation || '',
    currency: 'USD',
    index,
    item_brand: itemBrand,
    item_category: itemCategory,
    item_category2: subcategory,
    item_category3: itemCategory3,
    item_category4: itemCategory4,
    item_category5: itemCategory5,
    item_list_id: itemListId,
    item_list_name: itemListName,
    item_variant: itemVariant,
    location_id: Array.isArray(locationId) ? locationId.join('_') : locationId,
    price: parseToFloat(price),
    quantity: 1,
    discount: parseToFloat(discount) || 0,
  }
}
